import React, { Component } from "react"
import { List, Card, Icon, Button, Grid, Image } from "semantic-ui-react"
import { Link } from "react-router-dom"
import { translate } from "react-translate"
import ModalEditClient from "./ModalEditClient"
import "./Clients.css"

import client from '../../../assets/pro/client-icon.png';


class Client extends Component {
  constructor(props) {
    super(props)
    this.state = {}

    //this.handleSave = this.handleSave.bind(this)
  }

  // handleSave(clientData) {
  //   var tabCopy = clientsData.edit(this.state.clientsData, clientData)
  //   this.setState({
  //     clientsData: tabCopy
  //   })
  // }

  render() {
    let { name, firstName, adress, email, phone, type, t, edit } = this.props

    return (
      <Grid.Column mobile={16} tablet={8} computer={4} stackable container>
        <Card id="firstCardDisplay">
          <Card.Content id="cardContent" mobile={16} tablet={8} computer={4}>
            <Image src={client}/>

            <Card.Header id="CardHeader">
              {name} {""}
              {firstName}
            </Card.Header>
            <Link to={{ pathname: "/mtpro/devis", state: { prefill: name } }}>
              <Button
                id="buttonDevisFactures"
                mobile={16}
                tablet={8}
                computer={4}
                stackable
              >
                {t("card_client_title_devis_facture")}
              </Button>
            </Link>
            <ModalEditClient
              className="modalEditClient"
              onEdit={edit}
              {...this.props}
            />
          </Card.Content>
          <Card.Content mobile={16} tablet={8} computer={4}>
            <List divided relaxed>
              <List.Item>
                <List.Content>
                  <Icon name="map marker alternate" size="large" />
                  <List.Header className="cardHeaderContent">
                    {adress}
                  </List.Header>
                </List.Content>
              </List.Item>
              <List.Item>
                <List.Content>
                  <Icon name="mail" size="large" />
                  <List.Header as="a" className="cardHeaderContent">
                    {email}
                  </List.Header>
                </List.Content>
              </List.Item>
              <List.Item>
                <List.Content>
                  <Icon name="call" size="large" />
                  <List.Header as="a" className="cardHeaderContent">
                    {phone}
                  </List.Header>
                </List.Content>
              </List.Item>
            </List>
          </Card.Content>
        </Card>
      </Grid.Column>
    )
  }
}

export default translate("ProClient")(Client)



// WEBPACK FOOTER //
// ./src/components/Pro/Clients/Clients.jsx